module.exports = __webpack_public_path__ + "img/Ranking.0a7f29d5.svg";